window.domActions = function () {
	var instance = {
		setValue: function (args) {
			var e = document.getElementById(args.id);
			if (!e) {
				console.warn('setValue: element id=' + args.id + ' not found');
				return;
			}
			if (e) {
				if (e instanceof HTMLInputElement || e instanceof HTMLSelectElement)
					e.value = args.value;
				else
					e.innerHTML = args.value;
			}
		},
		setAttribute: function (args) {
			var e = document.getElementById(args.id);
			if (!e) {
				console.warn('setAttribute: element id=' + args.id + ' not found');
				return;
			}
			if (e instanceof HTMLSelectElement && args.attrName == 'readonly') {
				for (i = 0; i < e.options.length; i++) {
					if (e.value != e.options[i].value)
						e.options[i].setAttribute('disabled', 'disabled');
				}
				e.classList.add("readonly");
			}
			else
				e.setAttribute(args.attrName, args.attrValue);
		},
		removeAttribute: function (args) {
			var e = document.getElementById(args.id);
			if (!e) {
				console.warn('removeAttribute: element id=' + args.id + ' not found');
				return;
			}
			if (e instanceof HTMLSelectElement && args.attrName == 'readonly') {
				for (i = 0; i < e.options.length; i++) {
					e.options[i].removeAttribute('disabled');
				}
				e.classList.remove("readonly");
			}
			else
				e.removeAttribute(args.attrName);
		},
		setVisible: function (args) {
			var e = document.getElementById(args.id);
			if (!e) {
				console.warn('setVisible: element id=' + args.id + ' not found');
				return;
			}
			if (args.visible) e.classList.remove('hide'); else e.classList.add('hide');
		},
		setClass: function (args) {
			var e = document.getElementById(args.id);
			if (!e) {
				console.warn('setClass: element id=' + args.id + ' not found');
				return;
			}
			e.classList.add(args.clsName);
		},
		removeClass: function (args) {
			var e = document.getElementById(args.id);
			if (!e) {
				console.warn('removeClass: element id=' + args.id + ' not found');
				return;
			}
			e.classList.remove(args.clsName);
		},
		toggleClass: function (args) {
			event.stopPropagation();
			if (args.id) {
				var el = document.getElementById(args.id);
				el.classList.toggle(args.clsName);
			}
			else {
				var root = args.root ? args.root : document;
				var els = root.querySelectorAll(args.itemsSelector);
				var b = args.sender.classList.contains(args.senderClsName);
				if (args.senderState == 1) b = !b;

				if (args.groupSelector) {
					var grels = root.querySelectorAll(args.groupSelector);
					for (var i = 0; i < grels.length; i++) {
						grels[i].classList.remove(args.clsName);
						grels[i].classList.remove(args.senderClsName);
					}
				}

				if (!b) {
					for (var i = 0; i < els.length; i++) {
						els[i].classList.add(args.clsName);
					}
					if (args.senderState == 1) {
						args.sender.classList.remove(args.senderClsName);
					}
					else
						args.sender.classList.add(args.senderClsName);
				}
				else if (!args.groupSelector) {
					for (var i = 0; i < els.length; i++) {
						els[i].classList.remove(args.clsName);
					}
					if (args.senderState == 1) {
						args.sender.classList.add(args.senderClsName);
					}
					else
						args.sender.classList.remove(args.senderClsName);
				}
			}
		},
		hideShow: function (id) {
			instance.toggleClass({ id: id, clsName: 'hide' });
		},
		setCookie: function (args) {
			Cookies.set(args.id, args.value, { path: '/' });
		},
		setStorageArg: function (key, val) {
			sessionStorage.setItem(key, val);
			if (ajaxUtils.state.loc.storage.length == 0)
				ajaxUtils.state.loc.storage.push({});
			ajaxUtils.state.loc.storage[ajaxUtils.state.loc.storage.length - 1][key] = val;
		},
		include: function (id) {
			const i = document.getElementById(id);
			let path = i.getAttribute('data-include');
			if (path) {
				fetch(path).then(file => {
					file.text().then(content => {
						i.innerHTML = content;
					});
				});
			}
		}
	}

	return instance;
}();
